import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { Modal, Input, Button, notification, Alert } from 'antd';
import GoalSettingStepBar from 'components/goals/steps/GoalSettingStepBar';
import MissionStatement from 'components/goals/steps/MissionStatement';
import MonthRangePicker from 'components/commons/MonthRangePicker';
import ONumericInput from 'components/commons/ONumericInput';
import ONumericSlider from 'components/commons/ONumericSlider';
import OTextArea from 'components/commons/OTextArea';
import OTextField from 'components/commons/OTextField';
import OGoogleButton from 'components/commons/OGoogleButton';
import Goal from 'core/Goal';
import * as Messages from 'constants/Messages';
import { GoalCrudService, MetricsCrudService } from 'utils/CrudService';
import _ from 'lodash';

const Confirm = Modal.confirm;

class GoalSettingModal extends Component {
	constructor(props) {
		super(props);
		this.crudService = new GoalCrudService();
		this.metricsCrudService = new MetricsCrudService();
		this.googleService = props.googleService;
		this.translate = props.translate;

		this.state = {
			goal: props.goal,
			visible: false,
			exit: false,
			account: []
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.goal) {
			this.setState({ goal: nextProps.goal });
		}
	}

	render() {
		const t = this.translate;
		const currency = _.get(this.state, 'goal.currency');

		return (
			<Modal
				visible={this.state.visible}
				onOk={this.done.bind(this)}
				onCancel={this.showConfirm.bind(this)}
				className="goal-setting"
				width="50%"
				footer={null}
			>
				<GoalSettingStepBar ref="stepBar">
					<OTextArea
						title={t('goal.achieve.label')}
						container={this.state.goal}
						fieldName="statement"
						required={true}
						label={t('goal.achieve.question')}
					/>
					<Row title={t('goal.currency.label')}>
						<Col xs={12}>
							<OTextField
								container={this.state.goal}
								fieldName="currency"
								label={t('goal.currency.question')}
								onChange={this.onCurrencyChange.bind(this)}
							/>
						</Col>
						<Col xs={12}>
							<ONumericInput
								container={this.state.goal}
								fieldName="exchangeRate"
								prefix={currency}
								placeholder="(i.e) €0.86"
								label={t('goal.exchangeRate.question')}
							/>
						</Col>
					</Row>
					<Row title={t('goal.goal.label')}>
						<Col xs={12}>
							<ONumericInput
								container={this.state.goal}
								fieldName="financialGoal"
								placeholder="(i.e) $20000"
								prefix={currency}
								label={t('goal.goal.question')}
							/>
						</Col>
					</Row>
					<Row title={t('goal.period.label')}>
						<Col xs={12}>
							<h3>{t('goal.period.question')}</h3>
							<MonthRangePicker
								container={this.state.goal}
								startFieldName="startDate"
								endFieldName="endDate"
							/>
						</Col>
					</Row>
					<Row title={t('goal.workdays.label')}>
						<Col xs={12}>
							<ONumericInput
								container={this.state.goal}
								fieldName="monthlyWorkdays"
								suffix="day(s)"
								label={t('goal.workdays.question')}
							/>
						</Col>
					</Row>
					<Row title={t('goal.price.label')}>
						<Col xs={12}>
							<ONumericInput
								container={this.state.goal}
								fieldName='productPrice'
								prefix={currency}
								min={0}
								label={t('goal.price.question')} />
						</Col>
					</Row>
					<Row title={t('goal.google_account.label')}>
						<Col xs={12}>
							<OGoogleButton
								container={this.state.goal}
								accounts={this.state.accounts}
								googleService={this.googleService}
								googleAccount="googleAccount"
								accountId="accountId"
								webPropertyId="webPropertyId"
								profileId="profileId"
								buttonLabel={t('goal.google_account.buttonLabel')}
								label={t('goal.google_account.question')}
							/>
						</Col>
					</Row>
					<Row title={t('goal.trafficCTR.label')}>
						<Col xs={12}>
							<ONumericSlider
								container={this.state.goal}
								step={0.01}
								min={0.01}
								max={100}
								fieldName="ctr.traffic"
								defaultValue={0.01}
								suffix="%"
								label={t('goal.trafficCTR.question')}
							/>
						</Col>
					</Row>
					<Row title={t('goal.optinCTR.label')}>
						<Col xs={12}>
							<ONumericSlider
								container={this.state.goal}
								step={0.01}
								min={0.01}
								max={100}
								defaultValue={0.01}
								fieldName="ctr.optin"
								suffix="%"
								label={t('goal.optinCTR.question')}
							/>
						</Col>
					</Row>
					<Row title={t('goal.closeRate.label')}>
						<Col xs={12}>
							<ONumericSlider
								container={this.state.goal}
								step={0.01}
								min={0.01}
								max={100}
								defaultValue={0.01}
								fieldName="ctr.closerate"
								suffix="%"
								label={t('goal.closeRate.question')}
							/>
						</Col>
					</Row>
					<OTextArea
						title={t('goal.omissions.label')}
						container={this.state.goal}
						fieldName="omissions"
						label={t('goal.omissions.question')}
					/>
					<OTextArea
						title={t('goal.engage.label')}
						container={this.state.goal}
						fieldName="engagement"
						label={t('goal.engage.question')}
					/>
					<Row title={t('goal.done.label')}>
						<Col xs={12}>
							<Row start="md">
								<Col md={12}>
									<Alert
										message={t('goal.done.message')}
										description={t('goal.done.description')}
										type="success"
										showIcon
									/>
								</Col>
							</Row>
							<Row center="xs">
								<MissionStatement goal={this.state.goal} />
							</Row>
							<Row center="xs">
								<Button type="primary" onClick={() => this.done()}>
									{t('goal.done.label')}
								</Button>
							</Row>
						</Col>
					</Row>
				</GoalSettingStepBar>
			</Modal>
		);
	}

	onCurrencyChange(e) {
		this.setState({ goal: this.state.goal });
		console.log(e);
	}

	async done() {
		try {
			const goal = this.state.goal;
			this.setState({ loading: true });
			if (goal.id) {
				const goalId = await this.crudService.update(goal);
			} else {
				const newGoal = await this.crudService.create(goal);
				goal.id = newGoal.data;
			}
			await this.metricsCrudService.createOrUpdateMetrics(goal);
			this.state.goal.enabled = true;
			this.setState({ goal: this.state.goal, loading: false });
			this.onUpdate(this.state.goal);
			const role = _.get(this.props.user, 'role');
			if (role != 'test')
				notification.open({
					message: Messages.FORECAST_SUCCESS,
					description: Messages.FORECAST_SUCCESS_DESC
				});
			this.setState({ visible: false }, () => console.log('closed'));
			this.refs.stepBar.reset();
		} catch (e) {
			notification.open({ message: Messages.ERROR, description: e });
		}
	}

	componentDidCatch() {
		notification.open({
			message: Messages.FORECAST_SUCCESS,
			description: Messages.FORECAST_SUCCESS_DESC
		});
	}

	showConfirm(e) {
		e.preventDefault();
		Confirm({
			title: this.translate('modal.confirm'),
			onOk: () => {
				this.setState({ visible: false, exit: false }, () => console.log('closed'));
				this.setState({ goal: this.props.goal }, this.refs.stepBar.reset());
				this.onUpdate(this.props.goal);
			},
			onCancel: () => {},
			okText: 'Yes',
			cancelText: 'No'
		});
	}

	hideModal() {
		if (this.state.goal.goalId) {
			this.done();
		}
		this.setState({ visible: false, exit: false }, () => console.log('closed'));
		this.refs.stepBar.reset();
	}

	showModal(goal) {
		this.setState({ goal, visible: true }, () => console.log('opened'));
	}

	onUpdate(goal) {
		if (this.props.onUpdate) {
			this.props.onUpdate(goal);
		}
	}
}

export default GoalSettingModal;



// WEBPACK FOOTER //
// ./src/components/goals/GoalSettingModal.js